import React from 'react';
import { ReactComponent as CloseIcon } from '../../icon/closebuttonicon.svg';

const StopOperationPopup = ({ isOpen, onClose, content }) => {
  if (!isOpen) return null; // 팝업이 열려 있을 때만 렌더링

  const { stopType, stopReason, place, reason, actionHistory, delayReason } = content;

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center'>
      <div className='relative bg-white w-[80%] h-[70%] p-8 rounded-lg shadow-lg'>
        <button
          className='absolute top-[2%] right-[3%] md:right-[1%] text-gray-700 hover:text-gray-900'
          onClick={onClose}
        >
          <CloseIcon className='w-6 h-6' />
        </button>
        <div className='flex flex-col'>
          <div className='w-full bg-blue-200 change_h mt-[1.5%]'>
            <div className='w-full h-full flex ml-4 items-center font-bold c2_text'>중지내용 / 조치사항 / 지연사유</div>
            <table className='w-full table-auto border-collapse'>
              <tbody>
                <tr className='border-t border-gray-300'>
                  <td className='bg-navy text-white p-2 w-[90px] sm:w-[135px] md:w-[180px] border border-gray-300 c2_text'>
                    중지구분
                  </td>
                  <td className='p-2 border border-gray-300 c2_text'>{stopType}</td>
                </tr>
                <tr className='border-t border-gray-300'>
                  <td className='bg-navy text-white p-2 w-[90px] sm:w-[135px] md:w-[180px] border border-gray-300 c2_text'>
                    중지사유
                  </td>
                  <td className='p-2 border border-gray-300 c2_text'>{stopReason}</td>
                </tr>
                <tr className='border-t border-gray-300'>
                  <td className='bg-navy text-white p-2 w-[90px] sm:w-[135px] md:w-[180px] border border-gray-300 c2_text'>
                    <div className='flex flex-row'>
                      장<div className='ml-[30%] sm:ml-[20%] md:ml-[21%] '></div>소
                    </div>
                  </td>
                  <td className='p-2 border border-gray-300 c2_text'>{place}</td>
                </tr>
                <tr className='border-t border-gray-300'>
                  <td className=' bg-navy text-white p-2 w-[90px] sm:w-[135px] md:w-[180px] border border-gray-300 c2_text'>
                    <div className='flex flex-row'>
                      내<div className='ml-[30%] sm:ml-[20%] md:ml-[21%] '></div>용
                    </div>
                  </td>
                  <td className='p-2 border border-gray-300 c2_text'>{reason}</td>
                </tr>
                <tr className='border-t border-gray-300'>
                  <td className='bg-navy text-white p-2 w-[90px] sm:w-[135px] md:w-[180px] border border-gray-300 c2_text'>
                    조치내역
                  </td>
                  <td className='p-2 border border-gray-300 c2_text'>{actionHistory}</td>
                </tr>
                <tr className='border-t border-gray-300'>
                  <td className='bg-navy text-white p-2 w-[90px] sm:w-[135px] md:w-[180px] border border-gray-300 c2_text'>
                    지연사유
                  </td>
                  <td className='p-2 border border-gray-300 c2_text'>{delayReason || '없음'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StopOperationPopup;
